import { Pipe, PipeTransform } from '@angular/core';
import { SecurityService } from './security.service';

@Pipe({
  name: 'accessDataView',
  standalone: false,
})
export class AccessDataViewPipe implements PipeTransform {
  constructor(private readonly security: SecurityService) {}

  transform(
    value: string,
    permissions: string[],
    additionalCondition: boolean = true,
    defaultValue: string = '*******',
  ): string {
    if (!permissions) {
      throw new Error('Permissions were not set!');
    }
    if (additionalCondition && this.security.hasAccess(permissions)) {
      return value;
    } else {
      return defaultValue;
    }
  }
}
